import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    firestations: []
  },

  actions: {
    async getFirestations ({ commit, state }, { firefighterId, params = {} } = {}) {
      const response = await http.get(`firefighters/${id(firefighterId)}/firestations`, { params })
      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetFirestations ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.firestations = items
    }
  }
}
